import { literal, union } from 'io-ts/Decoder';

export const Certainty = union(literal('ai-suggested'), literal('user-confirmed'));
